/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Muddy_Born_Lynx_BendInputs */

const fr_muddy_born_lynx_bend = /** @type {(inputs: Muddy_Born_Lynx_BendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression d'un cours/programmation`)
};

/**

* @param {Muddy_Born_Lynx_BendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const muddy_born_lynx_bend = /** @type {((inputs?: Muddy_Born_Lynx_BendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Muddy_Born_Lynx_BendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_muddy_born_lynx_bend(inputs)
});